module.exports = __webpack_public_path__ + "media/images/icon__externalLink@3x-8cae193504911a56175132e492e4e02a.png";